import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import WhoWeHelpPage from "@/pages/WhoWeHelpPage";
import WhyUsPage from "@/pages/WhyUsPage";
import FAQPage from "@/pages/FAQPage";
import ApplyPage from "@/pages/ApplyPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";
import BlogPage from "@/pages/BlogPage";
import BlogPost10PromptsPage from "@/pages/BlogPost10PromptsPage";
import ResumeOptimizerPage from "@/pages/ResumeOptimizerPage";
import BlogPostAIMLResumePage from "@/pages/BlogPostAIMLResumePage";
import BlogPostLinkedInGuidePage from "@/pages/BlogPostLinkedInGuidePage";
import BlogPostPage from "@/pages/BlogPostPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppButton />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/how-it-works" element={<Layout><HowItWorksPage /></Layout>} />
          <Route path="/who-we-help" element={<Layout><WhoWeHelpPage /></Layout>} />
          <Route path="/why-us" element={<Layout><WhyUsPage /></Layout>} />
          <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
          <Route path="/apply" element={<Layout><ApplyPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
          <Route path="/blog/10-prompts-fix-resume" element={<Layout><BlogPost10PromptsPage /></Layout>} />
          <Route path="/blog/aiml-resume-tips" element={<Layout><BlogPostAIMLResumePage /></Layout>} />
          <Route path="/blog/linkedin-optimization-guide" element={<Layout><BlogPostLinkedInGuidePage /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPostPage /></Layout>} />
          <Route path="/resume-optimizer" element={<Layout><ResumeOptimizerPage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
